(function() {
  window.Bear = window.Bear || {};

  const BANNER_DISMISSED_KEY = 'bear_banner_dismissed';
  const POPUP_DISMISSED_KEY = 'bear_popup_dismissed';

  window.Bear.ui = {

    // ===== ANNOUNCEMENT BANNER =====
    initBanner: function() {
      const bannerHTML = `
        <div id="promo-banner" class="promo-banner">
          <span>All Enclosures are USA Made. For help or questions please call <strong>801-651-2431</strong></span>
        </div>
      `;

      // Insert banner at the beginning of body
      document.body.insertAdjacentHTML('afterbegin', bannerHTML);
      document.body.classList.add('banner-visible');
    },

    // ===== CART DRAWER =====
    initCartDrawer: function() {
      const drawerHTML = `
        <div id="cart-overlay" class="cart-overlay"></div>
        <aside id="cart-drawer" class="cart-drawer">
          <div class="cart-drawer-header">
            <h2>Your Cart (<span id="cart-drawer-count">0</span>)</h2>
            <button id="cart-drawer-close" aria-label="Close cart">✕</button>
          </div>
          <div id="cart-drawer-items" class="cart-drawer-items"></div>
          <div class="cart-drawer-footer">
            <div class="cart-drawer-total">Total: <strong id="cart-drawer-total">$0</strong></div>
            <button class="btn btn-solid cart-checkout-btn" onclick="Bear.ui.openCheckoutPrompt()">Proceed to Checkout</button>
          </div>
        </aside>
      `;

      document.body.insertAdjacentHTML('beforeend', drawerHTML);

      // Wire close button and overlay
      document.getElementById('cart-drawer-close').addEventListener('click', () => {
        this.closeCartDrawer();
      });

      document.getElementById('cart-overlay').addEventListener('click', () => {
        this.closeCartDrawer();
      });

      // Listen for cart changes and refresh drawer
      Bear.cart.onChange((items) => {
        this.refreshCartDrawer(items);
        this.updateCartBadge(items);
      });
    },

    refreshCartDrawer: function(items) {
      const container = document.getElementById('cart-drawer-items');
      const countSpan = document.getElementById('cart-drawer-count');
      const totalSpan = document.getElementById('cart-drawer-total');

      countSpan.textContent = items.length;

      // Calculate total (Shopify returns prices in cents)
      const total = items.reduce((sum, item) => sum + (item.price * item.quantity), 0) / 100;
      totalSpan.textContent = '$' + total.toFixed(2);

      if (items.length === 0) {
        container.innerHTML = '<div id="cart-drawer-empty" style="padding: 40px 20px; text-align: center; color: #999;">Your cart is empty</div>';
        return;
      }

      container.innerHTML = items.map((item, idx) => `
        <div class="cart-line-item" style="position: relative;">
          <div class="cart-line-thumbnail" style="background-image: url('${item.featured_image ? item.featured_image.url : ''}');"></div>
          <div class="cart-line-details">
            <div class="cart-line-title">${item.title}</div>
            ${item.options_with_values ? item.options_with_values.map(opt => `<div class="cart-line-variant">${opt.name}: ${opt.value}</div>`).join('') : ''}
            <div class="cart-line-price">$${(item.price / 100).toFixed(2)}</div>
            <div class="cart-line-qty-controls">
              <button class="cart-line-qty-btn" onclick="Bear.ui.updateLineQty('${item.id}', ${item.quantity - 1})">−</button>
              <input type="number" class="cart-line-qty-input" value="${item.quantity}" onchange="Bear.ui.updateLineQty('${item.id}', parseInt(this.value))">
              <button class="cart-line-qty-btn" onclick="Bear.ui.updateLineQty('${item.id}', ${item.quantity + 1})">+</button>
            </div>
          </div>
          <button class="cart-line-remove" onclick="Bear.ui.removeLineItem('${item.id}')">✕</button>
        </div>
      `).join('');
    },

    updateLineQty: function(variantId, qty) {
      if (qty < 1) {
        this.removeLineItem(variantId);
      } else {
        Bear.cart.updateQty(variantId, qty);
      }
    },

    removeLineItem: function(variantId) {
      Bear.cart.removeItem(variantId);
    },

    openCartDrawer: function() {
      const drawer = document.getElementById('cart-drawer');
      const overlay = document.getElementById('cart-overlay');
      drawer.classList.add('open');
      overlay.classList.add('open');
    },

    closeCartDrawer: function() {
      const drawer = document.getElementById('cart-drawer');
      const overlay = document.getElementById('cart-overlay');
      drawer.classList.remove('open');
      overlay.classList.remove('open');
    },

    // ===== CART BADGE =====
    updateCartBadge: function(items) {
      const badge = document.getElementById('cart-count-badge');
      if (badge) {
        const count = items ? items.length : 0;
        if (count > 0) {
          badge.textContent = count;
          badge.style.display = 'flex';
        } else {
          badge.style.display = 'none';
        }
      }
    },

    // ===== CHECKOUT =====
    openCheckoutPrompt: function() {
      // Redirect to Shopify checkout
      window.location.href = '/checkout';
    },

// ===== FAQ DATABASE =====
    faqDatabase: [
      { q: 'Will the enclosure reduce wind and dust?', a: 'Bear Enclosures are designed to greatly reduce wind and dust exposure. While small gaps exist around the enclosure, the reduction is significant and makes a noticeable difference in comfort during challenging conditions.' },
      { q: 'How difficult is the installation?', a: 'Our products use a custom clip system that allows them to be installed or removed quickly and easily, with minimal tools and minimal modification to your vehicle. Most riders can install in minutes.' },
      { q: 'Can I trailer my UTV with the enclosure on?', a: 'Yes. Bear Enclosures have been tested at highway speeds up to 75 mph when properly secured to the trailer. You can tow with confidence without removing the enclosure first.' },
      { q: 'What material are the enclosures made from?', a: 'Our enclosures are made from UV- and impact-resistant polycarbonate. The material is also abrasion-resistant to reduce scuffs, abrasions, and small scratches over time — keeping your enclosure looking great ride after ride.' },
      { q: 'Can the panels be tinted?', a: 'Yes. The polycarbonate panels are customizable and can be tinted if desired. Contact us to discuss tinting options for your specific enclosure.' },
      { q: 'Is Bear Enclosures made in the USA?', a: 'Absolutely. Every Bear Enclosure is proudly designed and manufactured in the USA. From raw materials to finished product, we hold ourselves to the highest standards of quality and craftsmanship.' }
    ],

    productDatabase: [
      { keywords: ['general', 'general 1000'], name: 'General 1000', url: 'shop.html' },
      { keywords: ['rzr', 'rzr xp 1000'], name: 'RZR XP 1000', url: 'shop.html' },
      { keywords: ['polaris'], name: 'Polaris Products', url: 'shop.html' },
      { keywords: ['can-am', 'canam', 'can am'], name: 'Can-Am Products', url: 'shop.html' },
      { keywords: ['honda'], name: 'Honda Products', url: 'shop.html' },
      { keywords: ['kawasaki'], name: 'Kawasaki Products', url: 'shop.html' },
      { keywords: ['yamaha'], name: 'Yamaha Products', url: 'shop.html' }
    ],

    searchFAQ: function(query) {
      const lowerQuery = query.toLowerCase();
      const keywords = lowerQuery.split(/\s+/).filter(k => k.length > 2);

      let matches = this.faqDatabase.map(item => {
        const questionLower = item.q.toLowerCase();
        let score = 0;
        keywords.forEach(keyword => {
          if (questionLower.includes(keyword)) score++;
        });
        return { ...item, score };
      }).filter(item => item.score > 0);

      matches.sort((a, b) => b.score - a.score);
      return matches.length > 0 ? matches[0] : null;
    },

    searchProducts: function(query) {
      const lowerQuery = query.toLowerCase();

      for (let product of this.productDatabase) {
        for (let keyword of product.keywords) {
          if (lowerQuery.includes(keyword)) {
            return product;
          }
        }
      }
      return null;
    },

    // ===== CUSTOMER CAROUSEL =====
    customerCarouselState: { currentIndex: 0 },

    updateCustomerCarouselDots: function() {
      for (let i = 0; i < 9; i++) {
        const dot = document.getElementById('carousel-dot-' + i);
        if (dot) {
          if (i === this.customerCarouselState.currentIndex) {
            dot.style.background = 'var(--accent)';
          } else {
            dot.style.background = 'rgba(200, 168, 75, 0.4)';
          }
        }
      }
    },

    showCustomerCarouselImage: function(index) {
      for (let i = 0; i < 9; i++) {
        const img = document.getElementById('carousel-image-' + i);
        if (img) {
          img.style.opacity = (i === index) ? '1' : '0';
        }
      }
      this.customerCarouselState.currentIndex = index;
      this.updateCustomerCarouselDots();
    },

    // ===== LIVE CHAT =====
    initLiveChat: function() {
      const chatHTML = `
        <div id="chat-bubble" class="chat-bubble" onclick="Bear.ui.toggleChatPanel()" title="Chat with us">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
          </svg>
        </div>
        <div id="chat-panel" class="chat-panel">
          <div class="chat-panel-header">
            <strong>Bear Enclosures Support</strong>
            <button id="chat-panel-close" onclick="Bear.ui.toggleChatPanel()">✕</button>
          </div>
          <div class="chat-panel-body">
            <div id="chat-initial">
              <p style="margin-bottom: 12px;">What can we help you with today?</p>
              <input type="text" id="chat-question" placeholder="ask us about our enclosures..." style="width: 100%; padding: 8px; margin-bottom: 8px; border: 1px solid #ddd; border-radius: 4px;">
              <button class="btn btn-solid" onclick="Bear.ui.searchQuestion()" style="width: 100%;">Ask</button>
            </div>
            <div id="chat-results" style="display: none;">
              <div id="result-content"></div>
              <button class="btn btn-solid" onclick="Bear.ui.resetChat()" style="width: 100%; margin-top: 12px;">Ask Another Question</button>
            </div>
            <div id="chat-thanks" style="display: none; text-align: center;">
              <strong style="display: block; margin-bottom: 8px;">✓ Thanks!</strong>
              <p style="font-size: 13px;">We'll be in touch within 1 business day.</p>
            </div>
          </div>
        </div>
      `;

      document.body.insertAdjacentHTML('beforeend', chatHTML);
    },

    toggleChatPanel: function() {
      const panel = document.getElementById('chat-panel');
      if (panel) {
        panel.classList.toggle('open');
      }
    },

    searchQuestion: function() {
      const input = document.getElementById('chat-question');
      const query = input.value.trim();

      if (!query) {
        alert('Please enter a question');
        return;
      }

      const resultsDiv = document.getElementById('chat-results');
      const contentDiv = document.getElementById('result-content');
      const initialDiv = document.getElementById('chat-initial');

      initialDiv.style.display = 'none';
      resultsDiv.style.display = 'block';

      let html = '';

      // Check if question is about returns
      const returnsKeywords = ['return', 'refund', 'warranty', 'guarantee', 'exchange', 'damaged', 'damage'];
      const lowerQuery = query.toLowerCase();
      const isReturnsQuestion = returnsKeywords.some(keyword => lowerQuery.includes(keyword));

      if (isReturnsQuestion) {
        html += `
          <div style="background: #f5f5f5; padding: 12px; border-radius: 4px; margin-bottom: 12px;">
            <p style="font-size: 14px; margin-bottom: 8px;"><strong>Returns & Warranty</strong></p>
            <p style="font-size: 13px; line-height: 1.5; margin-bottom: 12px;">We have a detailed Returns & Warranty page with information about our 30-day guarantee, return process, and warranty coverage.</p>
            <a href="returns.html" class="btn btn-solid" style="display: block; text-align: center; width: 100%;">View Returns & Warranty Policy</a>
          </div>
        `;
      } else {
        const faqResult = this.searchFAQ(query);
        const productResult = this.searchProducts(query);

          if (faqResult) {
            html += `
              <div style="background: #f5f5f5; padding: 12px; border-radius: 4px; margin-bottom: 12px;">
                <p style="font-size: 14px; margin-bottom: 8px;"><strong>${faqResult.q}</strong></p>
                <p style="font-size: 13px; line-height: 1.5;">${faqResult.a}</p>
              </div>
            `;
          }

          if (productResult) {
            html += `
              <div style="background: #f9f9f9; padding: 12px; border-radius: 4px; border-left: 3px solid var(--accent);">
                <p style="font-size: 13px; color: #666; margin-bottom: 8px;">Check out our collection:</p>
                <a href="${productResult.url}" class="btn btn-solid" style="display: block; text-align: center; width: 100%;">${productResult.name}</a>
              </div>
            `;
          }

          if (!faqResult && !productResult) {
            html += `
              <p style="font-size: 13px; color: #666; margin-bottom: 12px;">Send us an email and our team will get back to you within 1 business day.</p>
              <textarea id="chat-message" placeholder="Your question or message..." style="width: 100%; padding: 8px; margin-bottom: 8px; border: 1px solid #ddd; border-radius: 4px; font-family: var(--font-body); font-size: 13px; resize: vertical; min-height: 60px;"></textarea>
              <input type="email" id="chat-email" placeholder="your@email.com" style="width: 100%; padding: 8px; margin-bottom: 8px; border: 1px solid #ddd; border-radius: 4px;">
              <button class="btn btn-solid" onclick="Bear.ui.submitEmail()" style="width: 100%;">Send Email</button>
            `;
          }
        }

      contentDiv.innerHTML = html;
    },

    submitEmail: function() {
      const emailInput = document.getElementById('chat-email');
      const messageInput = document.getElementById('chat-message');
      const email = emailInput ? emailInput.value.trim() : '';
      const message = messageInput ? messageInput.value.trim() : '';

      if (!message) {
        alert('Please enter your message');
        return;
      }

      if (!email) {
        alert('Please enter your email');
        return;
      }

      document.getElementById('chat-results').style.display = 'none';
      document.getElementById('chat-thanks').style.display = 'block';

      setTimeout(() => {
        this.resetChat();
      }, 3000);
    },

    resetChat: function() {
      document.getElementById('chat-initial').style.display = 'block';
      document.getElementById('chat-results').style.display = 'none';
      document.getElementById('chat-thanks').style.display = 'none';
      document.getElementById('chat-question').value = '';
      const emailInput = document.getElementById('chat-email');
      if (emailInput) emailInput.value = '';
      const messageInput = document.getElementById('chat-message');
      if (messageInput) messageInput.value = '';
    },

    // ===== INIT ALL =====
    initAll: function() {
      this.initBanner();
      this.initCartDrawer();
      this.updateCartBadge();
      this.initLiveChat();
    },

    // ===== DEBUG =====
    clearDismissals: function() {
      localStorage.removeItem(BANNER_DISMISSED_KEY);
      localStorage.removeItem(POPUP_DISMISSED_KEY);
      console.log('Dismissal flags cleared. Reload page to test.');
    }
  };
})();

// Global carousel functions for inline onclick handlers
window.customerCarouselPrev = function() {
  const current = window.Bear.ui.customerCarouselState.currentIndex;
  const prev = (current - 1 + 9) % 9;
  window.Bear.ui.showCustomerCarouselImage(prev);
};

window.customerCarouselNext = function() {
  const current = window.Bear.ui.customerCarouselState.currentIndex;
  const next = (current + 1) % 9;
  window.Bear.ui.showCustomerCarouselImage(next);
};

window.customerCarouselGoto = function(index) {
  window.Bear.ui.showCustomerCarouselImage(index);
};
